import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavHomeActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.48 10.93L13.3 0.750022C12.58 0.030022 11.41 0.030022 10.69 0.750022L0.51999 10.93C0.22999 11.22 0.22999 11.7 0.51999 11.99C0.75999 12.23 1.10999 12.26 1.39999 12.11V21.86C1.39999 22.88 2.22999 23.7 3.23999 23.7H20.76C21.78 23.7 22.61 22.87 22.61 21.86V12.11C22.72 12.17 22.83 12.21 22.96 12.21C23.15 12.21 23.34 12.14 23.49 11.99C23.78 11.7 23.78 11.22 23.49 10.93H23.48ZM8.70999 14.19H15.28V22.2H8.70999V14.19Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavHomeActiveIcon.displayName = 'NavHomeActiveIcon';
